// extracted by mini-css-extract-plugin
export default {"wrapper":"Delivery_wrapper__D8WYP","header":"Delivery_header__yRt82","goBack":"Delivery_goBack__X0naH","container":"Delivery_container__f46IF"};